import {useState, useEffect, useRef}        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
import {
        getTeachingStructureList,
        getSchoolByID,
        getAreaByID,
        getProgramByID,
        getCustomerByID,    
        getAcademicAreaByID,
        updateSchool,
        deleteSchool,
        updateArea,
        deleteArea,
        updateProgram,
        deleteProgram,
        updateCustomer,
        deleteCustomer,
        updateAcademicArea,
        deleteAcademicArea
    }                                       from "./teachingStructureService";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import {q3x_FunData, 
        getImgSrc, 
        DefaultLoadingLogo,
        DavidCopperfield,
        Heimdall,
        GetLabel,
        GetAppLang,
        SetLastFeature}                     from "Utilities/utils"
import { Select }                           from "antd";
import { useNavigate }                      from "react-router-dom";


let blank_school_obj = {
    'SCHOOL_ID':            0,
    'SCHOOL_DESC':          "",
    'SCHOOL_USERS_LIST':    [],
    'USERS_LIST':           []
};
let blank_area_obj = {
    'AREA_ID':          0,
    'AREA_DESC':        0,
    'SCHOOL_ID':        0,
    'SCHOOL_DESC':      "",
    'UPDATED':          "",
    'SCHOOL_LIST':      [],
    'AREA_USERS_LIST':  [],
    'USERS_LIST':       []
};
let blank_program_obj = {
    'PROGRAM_ID':           0,
    'PROGRAM_DESC':         "",
    'AREA_ID':              0,
    'AREA_DESC':            "",
    'UPDATED':              "",
    'AREA_LIST':            [],
    'PROGRAM_USERS_LIST':   [],
    'USERS_LIST':           []
};
let blank_client_obj = {
    'CLIENT_ID':            0,
    'CLIENT_DESC':          "",
    'UPDATED':              "",
    'CLIENTS_USERS_LIST':   [],
    'USERS_LIST':           []
};
let blank_academic_area_obj = {
    'ACADEMIC_AREA_ID':         0,
    'ACADEMIC_AREA_DESC':       "",
    'UPDATED':                  "",
    'ACADEMIC_AREA_USERS_LIST': [],
    'USERS_LIST':               []
};
let blank_user_obj = {
    'USER_ID': 0,
    'FULL_NAME': "",
    'SECTOR_DESC': "",
    'FILE_DATA': ""
};
let appLang = null;
/*
const SearchableDropdownList = ({
    className,
    style,
    onChange,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={listOfItems}
      className={className}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      title={title}
      popupClassName={popupClassName}
      value={value}
    />
  );
};
*/
const SearchableDropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};

const Avatar = () => {
    return (
        <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
            <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
            <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
            <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
            <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
        </svg>
    );
};

{/*             Panels related             */}
const SchoolEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader      }       = useLoader();                  // Control over the loader
    const { showInfoMessage             }       = useInfoMsgModal();            // Modal message control 
    const { showActionMessage           }       = useActionModal();             // Modal message + action control     
    const { showToastMessage            }       = useToastMessage();            // Toast message display
    const [ schoolObj,   setSchoolObj   ]       = useState(blank_school_obj);   // Sector Object
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_school_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };      

    const handleSave = async () => {
        if (schoolObj.SCHOOL_DESC == "") {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 279)});
            return;            
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateSchool(schoolObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (schoolObj.SCHOOL_ID === 0) {
                    setProps({ setScreen: 1, data: blank_school_obj });
                }
                //setProps({ setScreen: 1, data: blank_school_obj });
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteSchool(schoolObj.SCHOOL_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_school_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {        
        setSchoolObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const UserHasAccess = ({objectSet, dataset}) => {

        const handleDelete = (item_id) => {
            const newList = dataset.filter(user => user.USER_ID !== item_id);
            objectSet({ SCHOOL_USERS_LIST: newList });
        };

        useEffect(() => {
        }, [ dataset ]);
        
        return (
            <>
                <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                     style={dataset.length > 0 ? {height: '20rem'}: null}
                >
                    {
                        dataset.map((data) => {
                            return (
                                <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                        <div className={MainStyle.col_1}/>
                                        <div className={MainStyle.col_10}>
                                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                    className={[MainStyle.border,
                                                                MainStyle.shadow, 
                                                                MainStyle.rounded_circle,
                                                                MainStyle.my_2].join(" ")}
                                                >
                                                    {   
                                                        data.FILE_DATA != null ?
                                                            <img 
                                                                src={getImgSrc(data.FILE_DATA)} 
                                                                style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                            />
                                                        :
                                                            <Avatar/>
                                                    }
                                                </div>
                                                <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FULL_NAME} {GetLabel(appLang, 44)} {data.SECTOR_DESC}</p>
                                                <div 
                                                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                    onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                                >
                                                    <svg 
                                                        xmlns="http://www.w3.org/2000/svg" 
                                                        viewBox="0 0 448 512"
                                                        className={[MainStyle.small_ico_generic].join(" ")}
                                                    >
                                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_1}/>
                                </div>
                            );
                        })
                    }                        
                </div>
            </>
        );

    };

    const handlePermissionList = (user_id) => {
        if (schoolObj.SCHOOL_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            return;
        }
        // Find in list
        const foundObj = schoolObj.USERS_LIST.find((u) => u.USER_ID === user_id);
        if (!foundObj) return; // Safety check in case the object isn't found
    
        // Create a new object
        const newObj = {
            ...blank_user_obj, // Copy the template
            USER_ID:        foundObj.USER_ID,
            FULL_NAME:      foundObj.FULL_NAME,
            SECTOR_DESC:    foundObj.SECTOR_DESC,
            FILE_DATA:     foundObj.FILE_DATA
        };
    
        // Update state correctly by creating a new array
        setSchoolObj(prevState => ({
            ...prevState,
            SCHOOL_USERS_LIST: [...prevState.SCHOOL_USERS_LIST, newObj]
        }));

    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 280) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        if (schoolObj.SCHOOL_USERS_LIST.length > 0) {
            let message = "";
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 281)});
            return;            
        }
        showActionMessage(
          { header: GetLabel(appLang, 54), message:  GetLabel(appLang, 282)},
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (school_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getSchoolByID(school_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;                            
                            // Set main Object 
                            setSchoolObj(fetchedData || blank_school_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setSchoolObj(blank_school_obj);
            }
        };
        if (data?.SCHOOL_ID && data.SCHOOL_ID !== 0) {
            fetchData(data.SCHOOL_ID);
        } 
        else {
            fetchData(0);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 283)} *:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                                value={schoolObj.SCHOOL_DESC}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleChange({ SCHOOL_DESC: q3x_FunData(event.target.value) })}
                                                placeholder={GetLabel(appLang, 284)}
                                                maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{schoolObj.SCHOOL_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 285)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 286)}
                                    listOfItems={
                                            schoolObj.USERS_LIST.map((u) => (
                                            {
                                                value: u.USER_ID, 
                                                label: `${u.FULL_NAME} de ${u.SECTOR_DESC } (${u.EMAIL})`
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handlePermissionList(event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access           */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 287)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mt_3}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} dataset={schoolObj.SCHOOL_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mb_5}/>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}/>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,6) && (
                        schoolObj.SCHOOL_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};
const AreaEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader     }  = useLoader();              // Control over the loader
    const { showInfoMessage            }  = useInfoMsgModal();        // Modal message control 
    const { showActionMessage          }  = useActionModal();         // Modal message + action control     
    const { showToastMessage           }  = useToastMessage();        // Toast message display
    const [areaObj,         setAreaObj ]  = useState(blank_area_obj); // Sector Object
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_area_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };     

    const handleSave = async () => {
        if (areaObj.AREA_DESC == "") {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 288)});
            return;            
        }
        else if (areaObj.SCHOOL_ID == 0){
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 289)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateArea(areaObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (areaObj.AREA_ID === 0) {
                    setProps({ setScreen: 1, data: blank_area_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteArea(areaObj.AREA_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_area_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {        
        setAreaObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const UserHasAccess = ({objectSet, dataset}) => {

        const handleDelete = (item_id) => {
            const newList = dataset.filter(user => user.USER_ID !== item_id);
            objectSet({ AREA_USERS_LIST: newList });
        };

        useEffect(() => {
        }, [ dataset ]);

        return (
            <>
                <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                     style={dataset.length > 0 ? {height: '20rem'}: null}
                >
                    {
                        dataset.map((data) => {
                            return (
                                <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                        <div className={MainStyle.col_1}/>
                                        <div className={MainStyle.col_10}>
                                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                            <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                 className={[MainStyle.border,
                                                             MainStyle.shadow, 
                                                             MainStyle.rounded_circle,
                                                             MainStyle.my_2].join(" ")}
                                            >
                                                    {
                                                        data.FILE_DATA != null ?
                                                            <img 
                                                                src={getImgSrc(data.FILE_DATA)} 
                                                                style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                            />
                                                        :
                                                            <Avatar/>
                                                    }
                                                </div>
                                                <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FULL_NAME} {GetLabel(appLang, 44)} {data.SECTOR_DESC}</p>
                                                <div 
                                                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                    onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                                >
                                                    <svg 
                                                        xmlns="http://www.w3.org/2000/svg" 
                                                        viewBox="0 0 448 512"
                                                        className={[MainStyle.small_ico_generic].join(" ")}
                                                    >
                                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_1}/>
                                </div>
                            );
                        })
                    }                        
                </div>
            </>
        );

    };

    const handlePermissionList = (user_id) => {
        if (areaObj.AREA_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            return;
        }
        // Find in list
        const foundObj = areaObj.USERS_LIST.find((u) => u.USER_ID === user_id);
        if (!foundObj) return; // Safety check in case the object isn't found
    
        // Create a new object
        const newObj = {
            ...blank_user_obj, // Copy the template
            USER_ID:        foundObj.USER_ID,
            FULL_NAME:      foundObj.FULL_NAME,
            SECTOR_DESC:    foundObj.SECTOR_DESC,
            FILE_DATA:      foundObj.FILE_DATA
        };
    
        // Update state correctly by creating a new array
        setAreaObj(prevState => ({
            ...prevState,
            AREA_USERS_LIST: [...prevState.AREA_USERS_LIST, newObj]
        }));

    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 290) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        if (areaObj.AREA_USERS_LIST.length > 0) {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 291)});
            return;            
        }
        showActionMessage(
          { header: GetLabel(appLang, 54), message:  GetLabel(appLang, 292)},
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (area_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getAreaByID(area_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;                            
                            // Set main Object 
                            setAreaObj(fetchedData || blank_area_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setAreaObj(blank_area_obj);
            }
        };
        if (data?.AREA_ID && data.AREA_ID !== 0) {
            fetchData(data.AREA_ID);
        } 
        else {
            fetchData(0);
        }
    }, [data]);
    
    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    {/*                        Area description                      */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 293)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                    value={areaObj.AREA_DESC}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                    onChange={(event) => handleChange({ AREA_DESC: q3x_FunData(event.target.value) })}
                                    placeholder={GetLabel(appLang, 294)}
                                    maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{areaObj.AREA_DESC.length} de 150 caracteres.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                  Selection of School List                    */}
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 295)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 296)}                                       
                                    listOfItems={
                                            areaObj?.SCHOOL_LIST.map((s) => (
                                            {
                                                value: s.SCHOOL_ID, 
                                                label: s.SCHOOL_DESC
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handleChange({SCHOOL_ID: event});
                                    }}
                                    value={areaObj?.SCHOOL_ID > 0 ? parseInt(areaObj.SCHOOL_ID) : undefined}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                  Selection of user List                      */}
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 285)}
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 286)}                                       
                                    listOfItems={
                                            areaObj.USERS_LIST.map((u) => (
                                            {
                                                value: u.USER_ID, 
                                                label: `${u.FULL_NAME} de ${u.SECTOR_DESC } (${u.EMAIL})`
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handlePermissionList(event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access header          */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 287)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access                 */}
                    <div className={MainStyle.mt_3}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} dataset={areaObj.AREA_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mb_5}/>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,6) && (
                        areaObj.AREA_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};
const ProgramEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader      }   = useLoader();                  // Control over the loader
    const { showInfoMessage             }   = useInfoMsgModal();            // Modal message control 
    const { showActionMessage           }   = useActionModal();             // Modal message + action control     
    const { showToastMessage            }   = useToastMessage();            // Toast message display
    const [programObj,  setProgramObj   ]   = useState(blank_program_obj);  // Main Object

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_program_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };     

    const handleSave = async () => {
        if (programObj.PROGRAM_DESC == "") {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 297)});
            return;            
        }
        else if (programObj.AREA_ID == 0){
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 298)});
            return;
        }
        
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateProgram(programObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (programObj.PROGRAM_ID === 0) {
                    setProps({ setScreen: 1, data: blank_program_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteProgram(programObj.PROGRAM_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_program_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {        
        setProgramObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const UserHasAccess = ({objectSet, dataset}) => {

        const handleDelete = (item_id) => {
            const newList = dataset.filter(user => user.USER_ID !== item_id);
            objectSet({ PROGRAM_USERS_LIST: newList });
        };

        useEffect(() => {
        }, [ dataset ]);

        return (
            <>
                <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                     style={dataset.length > 0 ? {height: '20rem'}: null}
                >
                    {
                        dataset.map((data) => {
                            return (
                                <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                        <div className={MainStyle.col_1}/>
                                        <div className={MainStyle.col_10}>
                                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                            <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                 className={[MainStyle.border,
                                                             MainStyle.shadow, 
                                                             MainStyle.rounded_circle,
                                                             MainStyle.my_2].join(" ")}
                                            >
                                                    {
                                                        data.FILE_DATA != null ?
                                                            <img 
                                                                src={getImgSrc(data.FILE_DATA)} 
                                                                style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                            />
                                                        :
                                                            <Avatar/>
                                                    }
                                                </div>
                                                <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FULL_NAME} {GetLabel(appLang, 44)} {data.SECTOR_DESC}</p>
                                                <div 
                                                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                    onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                                >
                                                    <svg 
                                                        xmlns="http://www.w3.org/2000/svg" 
                                                        viewBox="0 0 448 512"
                                                        className={[MainStyle.small_ico_generic].join(" ")}
                                                    >
                                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_1}/>
                                </div>
                            );
                        })
                    }                        
                </div>
            </>
        );

    };

    const handlePermissionList = (user_id) => {
        if (programObj.PROGRAM_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            return;
        }
        // Find in list
        const foundObj = programObj.USERS_LIST.find((u) => u.USER_ID === user_id);
        if (!foundObj) return; // Safety check in case the object isn't found
    
        // Create a new object
        const newObj = {
            ...blank_user_obj, // Copy the template
            USER_ID:        foundObj.USER_ID,
            FULL_NAME:      foundObj.FULL_NAME,
            SECTOR_DESC:    foundObj.SECTOR_DESC,
            FILE_DATA:      foundObj.FILE_DATA
        };
    
        // Update state correctly by creating a new array
        setProgramObj(prevState => ({
            ...prevState,
            PROGRAM_USERS_LIST: [...prevState.PROGRAM_USERS_LIST, newObj]
        }));

    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 299) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        if (programObj.PROGRAM_USERS_LIST.length > 0) {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 300)});
            return;            
        }
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 301) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (program_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getProgramByID(program_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;                            
                            // Set main Object 
                            setProgramObj(fetchedData || blank_program_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setProgramObj(blank_program_obj);
            }
        };
        if (data?.PROGRAM_ID && data.PROGRAM_ID !== 0) {
            fetchData(data.PROGRAM_ID);
        } 
        else {
            fetchData(0);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    {/*           Program description                               */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 302)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                    value={programObj.PROGRAM_DESC}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                    onChange={(event) => handleChange({ PROGRAM_DESC: q3x_FunData(event.target.value) })}
                                    placeholder={GetLabel(appLang, 303)}
                                    maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{programObj.PROGRAM_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*           Selection of Area List                            */}
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 304)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 305)}                                       
                                    listOfItems={
                                            programObj?.AREA_LIST.map((a) => (
                                            {
                                                value: a.AREA_ID, 
                                                label: a.AREA_DESC
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handleChange({AREA_ID: event});
                                    }}
                                    value={programObj.AREA_ID > 0 ? parseInt(programObj.AREA_ID) : undefined}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*           Selection of user List                            */}
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 285)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 286)}                                       
                                    listOfItems={
                                            programObj.USERS_LIST.map((u) => (
                                            {
                                                value: u.USER_ID, 
                                                label: `${u.FULL_NAME} de ${u.SECTOR_DESC } (${u.EMAIL})`
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handlePermissionList(event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access header          */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 287)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access                 */}
                    <div className={MainStyle.mt_3}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} dataset={programObj.PROGRAM_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mb_5}/>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,6) && (
                        programObj.PROGRAM_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};
const CustomerEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader      }   = useLoader();                  // Control over the loader
    const { showInfoMessage             }   = useInfoMsgModal();            // Modal message control 
    const { showActionMessage           }   = useActionModal();             // Modal message + action control     
    const { showToastMessage            }   = useToastMessage();            // Toast message display
    const [clientObj,       setClientObj]   = useState(blank_client_obj);   // Customer Object

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_client_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    }; 

    const handleSave = async () => {
        if (clientObj.CLIENT_DESC == "") {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 306)});
            return;            
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateCustomer(clientObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (clientObj.CLIENT_ID === 0) {
                    setProps({ setScreen: 1, data: blank_client_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteCustomer(clientObj.CLIENT_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_client_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {        
        setClientObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const UserHasAccess = ({objectSet, dataset}) => {

        const handleDelete = (item_id) => {
            const newList = dataset.filter(user => user.USER_ID !== item_id);
            objectSet({ CLIENTS_USERS_LIST: newList });
        };

        useEffect(() => {
        }, [ dataset ]);
        
        return (
            <>
                <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                     style={dataset.length > 0 ? {height: '20rem'}: null}
                >
                    {
                        dataset.map((data) => {
                            return (
                                <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                        <div className={MainStyle.col_1}/>
                                        <div className={MainStyle.col_10}>
                                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                    className={[MainStyle.border,
                                                                MainStyle.shadow, 
                                                                MainStyle.rounded_circle,
                                                                MainStyle.my_2].join(" ")}
                                                >
                                                    {   
                                                        data.FILE_DATA != null ?
                                                            <img 
                                                                src={getImgSrc(data.FILE_DATA)} 
                                                                style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                            />
                                                        :
                                                            <Avatar/>
                                                    }
                                                </div>
                                                <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FULL_NAME} {GetLabel(appLang, 44)} {data.SECTOR_DESC}</p>
                                                <div 
                                                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                    onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                                >
                                                    <svg 
                                                        xmlns="http://www.w3.org/2000/svg" 
                                                        viewBox="0 0 448 512"
                                                        className={[MainStyle.small_ico_generic].join(" ")}
                                                    >
                                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_1}/>
                                </div>
                            );
                        })
                    }                        
                </div>
            </>
        );

    };

    const handlePermissionList = (user_id) => {
        if (clientObj.CLIENTS_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            return;
        }
        // Find in list
        const foundObj = clientObj.USERS_LIST.find((u) => u.USER_ID === user_id);
        if (!foundObj) return; // Safety check in case the object isn't found
    
        // Create a new object
        const newObj = {
            ...blank_user_obj, // Copy the template
            USER_ID:        foundObj.USER_ID,
            FULL_NAME:      foundObj.FULL_NAME,
            SECTOR_DESC:    foundObj.SECTOR_DESC,
            FILE_DATA:     foundObj.FILE_DATA
        };
    
        // Update state correctly by creating a new array
        setClientObj(prevState => ({
            ...prevState,
            CLIENTS_USERS_LIST: [...prevState.CLIENTS_USERS_LIST, newObj]
        }));

    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 307) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        if (clientObj.CLIENTS_USERS_LIST.length > 0) {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 308)});
            return;            
        }
        showActionMessage(
          { header: GetLabel(appLang, 54), message:  GetLabel(appLang, 309)},
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (customer_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getCustomerByID(customer_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;                            
                            // Set main Object 
                            setClientObj(fetchedData || blank_client_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setClientObj(blank_client_obj);
            }
        };
        if (data?.CLIENT_ID && data.CLIENT_ID !== 0) {
            fetchData(data.CLIENT_ID);
        } 
        else {
            fetchData(0);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 310)} *:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                                value={clientObj.CLIENT_DESC}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleChange({ CLIENT_DESC: q3x_FunData(event.target.value) })}
                                                placeholder={GetLabel(appLang, 311)}
                                                maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{clientObj.CLIENT_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 285)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 286)}
                                    listOfItems={
                                            clientObj.USERS_LIST.map((u) => (
                                            {
                                                value: u.USER_ID, 
                                                label: `${u.FULL_NAME} de ${u.SECTOR_DESC } (${u.EMAIL})`
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handlePermissionList(event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access           */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 287)}
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mt_3}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} dataset={clientObj.CLIENTS_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mb_5}/>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,6) && (
                        clientObj.CLIENT_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};
const AcademicAreaEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader                } = useLoader();                          // Control over the loader
    const { showInfoMessage                       } = useInfoMsgModal();                    // Modal message control 
    const { showActionMessage                     } = useActionModal();                     // Modal message + action control     
    const { showToastMessage                      } = useToastMessage();                    // Toast message display
    const [academicAreaObj,     setAcademicAreaObj] = useState(blank_academic_area_obj);    // Sector Object
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_academic_area_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };     

    const handleSave = async () => {
        if (academicAreaObj.ACADEMIC_AREA_DESC == "") {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 312)});
            return;            
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateAcademicArea(academicAreaObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (academicAreaObj.ACADEMIC_AREA_ID === 0) {
                    setProps({ setScreen: 1, data: blank_client_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteAcademicArea(academicAreaObj.ACADEMIC_AREA_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_academic_area_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {        
        setAcademicAreaObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const UserHasAccess = ({objectSet, dataset}) => {

        const handleDelete = (item_id) => {
            const newList = dataset.filter(user => user.USER_ID !== item_id);
            objectSet({ ACADEMIC_AREA_USERS_LIST: newList });
        };

        useEffect(() => {
        }, [ dataset ]);
        
        return (
            <>
                <div className={dataset.length > 0 ? MainStyle.overflow_y_scroll : null}
                     style={dataset.length > 0 ? {height: '20rem'}: null}
                >
                    {
                        dataset.map((data) => {
                            return (
                                <div  key={data.USER_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom].join(" ")}>
                                        <div className={MainStyle.col_1}/>
                                        <div className={MainStyle.col_10}>
                                            <div className={[MainStyle.d_flex, MainStyle.justify_content_between, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                <div style={{ maxWidth: '4rem', aspectRatio: '1 / 1', overflow: 'hidden' }}
                                                    className={[MainStyle.border,
                                                                MainStyle.shadow, 
                                                                MainStyle.rounded_circle,
                                                                MainStyle.my_2].join(" ")}
                                                >
                                                    {   
                                                        data.FILE_DATA != null ?
                                                            <img 
                                                                src={getImgSrc(data.FILE_DATA)} 
                                                                style={{width: '100%', height: '100%', objectFit:'cover', objectPosition: 'center'}}
                                                            />
                                                        :
                                                            <Avatar/>
                                                    }
                                                </div>
                                                <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FULL_NAME} {GetLabel(appLang, 44)} {data.SECTOR_DESC}</p>
                                                <div 
                                                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                    onClick={() => {handleDelete(data.USER_ID)}}                                                 
                                                >
                                                    <svg 
                                                        xmlns="http://www.w3.org/2000/svg" 
                                                        viewBox="0 0 448 512"
                                                        className={[MainStyle.small_ico_generic].join(" ")}
                                                    >
                                                        <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_1}/>
                                </div>
                            );
                        })
                    }                        
                </div>
            </>
        );

    };

    const handlePermissionList = (user_id) => {
        if (academicAreaObj.ACADEMIC_AREA_USERS_LIST.some((u) => u.USER_ID === user_id)) {
            return;
        }
        // Find in list
        const foundObj = academicAreaObj.USERS_LIST.find((u) => u.USER_ID === user_id);
        if (!foundObj) return; // Safety check in case the object isn't found
    
        // Create a new object
        const newObj = {
            ...blank_user_obj, // Copy the template
            USER_ID:        foundObj.USER_ID,
            FULL_NAME:      foundObj.FULL_NAME,
            SECTOR_DESC:    foundObj.SECTOR_DESC,
            FILE_DATA:      foundObj.FILE_DATA
        };
    
        // Update state correctly by creating a new array
        setAcademicAreaObj(prevState => ({
            ...prevState,
            ACADEMIC_AREA_USERS_LIST: [...prevState.ACADEMIC_AREA_USERS_LIST, newObj]
        }));

    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 313) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        if (academicAreaObj.ACADEMIC_AREA_USERS_LIST.length > 0) {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': GetLabel(appLang, 314)});
            return;            
        }
        showActionMessage(
          { header: GetLabel(appLang, 54), message:  GetLabel(appLang, 315)},
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (academic_area_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getAcademicAreaByID(academic_area_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;                            
                            // Set main Object 
                            setAcademicAreaObj(fetchedData || blank_academic_area_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setAcademicAreaObj(blank_academic_area_obj);
            }
        };
        if (data?.ACADEMIC_AREA_ID && data.ACADEMIC_AREA_ID !== 0) {
            fetchData(data.ACADEMIC_AREA_ID);
        } 
        else {
            fetchData(0);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 316)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                                value={academicAreaObj.ACADEMIC_AREA_DESC}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleChange({ ACADEMIC_AREA_DESC: q3x_FunData(event.target.value) })}
                                                placeholder={GetLabel(appLang, 317)}
                                                maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{academicAreaObj.ACADEMIC_AREA_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 285)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 286)}                                       
                                    listOfItems={
                                            academicAreaObj.USERS_LIST.map((u) => (
                                            {
                                                value: u.USER_ID, 
                                                label: `${u.FULL_NAME} de ${u.SECTOR_DESC } (${u.EMAIL})`
                                            }
                                            ))
                                    }
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {
                                        handlePermissionList(event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {/*           List of users that can have access           */}
                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 287)}:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mt_3}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            <UserHasAccess objectSet={handleChange} dataset={academicAreaObj.ACADEMIC_AREA_USERS_LIST}/>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={MainStyle.mb_5}/>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,6) && (
                        academicAreaObj.ACADEMIC_AREA_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(3,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};

{/*             Grid related             */}

{/*    
    Handle each table individually to be more easy to manage 
    with less complex logic with the table list and handle data.
*/}
const SchoolTableGrid       = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_school_obj));
            obj_copy.SCHOOL_ID = props.data.SCHOOL_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(3,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "SCHOOL_ID"      ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 318),  field: "SCHOOL_DESC"    ,filter: true , flex: 1,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getTeachingStructureList(1);
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};
const AreaTableGrid         = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_area_obj));
            obj_copy.AREA_ID = props.data.AREA_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(3,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "AREA_ID"      ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 319),  field: "AREA_DESC"    ,filter: true , flex: 1,}    ,
        { headerName: GetLabel(appLang, 318),  field: "SCHOOL_DESC"  ,filter: true , flex: 0,}    ,
        { headerName: GetLabel(appLang, 320),  field: "HIERARCHY"    ,filter: true , flex: 0,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getTeachingStructureList(2);
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};
const ProgramTableGrid      = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_program_obj));
            obj_copy.PROGRAM_ID = props.data.PROGRAM_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(3,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),  field: "PROGRAM_ID"      ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 321), field: "PROGRAM_DESC"    ,filter: true , flex: 1,}    ,
        { headerName: GetLabel(appLang, 319), field: "AREA_DESC"       ,filter: true , flex: 0,}    ,
        { headerName: GetLabel(appLang, 318), field: "SCHOOL_DESC"     ,filter: true , flex: 0,}    ,
        { headerName: GetLabel(appLang, 320), field: "HIERARCHY"       ,filter: true , flex: 0,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getTeachingStructureList(3);
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};
const CustomerTableGrid     = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_client_obj));
            obj_copy.CLIENT_ID = props.data.CLIENT_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(3,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),  field: "CLIENT_ID"      ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 322),  field: "CLIENT_DESC"    ,filter: true , flex: 1,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getTeachingStructureList(4);
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};
const AcademicAreaTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_academic_area_obj));
            obj_copy.ACADEMIC_AREA_ID = props.data.ACADEMIC_AREA_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(3,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),  field: "ACADEMIC_AREA_ID"      ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 323), field: "ACADEMIC_AREA_DESC"    ,filter: true , flex: 1,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getTeachingStructureList(5);
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const TeachingStructurePage = () => {
    const [ screenType, setScreenType ]       = useState(1);
    const [ tableType, setTableType ]         = useState(1);
    const [ defaultData, setDefaultData]      = useState({});
    const navigate                            = useNavigate();    

    const BtnNewSchool = () => {
        handleChange({ setScreen: 2, data: blank_school_obj });
    };
    const BtnNewArea = () => {
        handleChange({ setScreen: 2, data: blank_area_obj });
    };
    const BtnNewProgram = () => {
        handleChange({ setScreen: 2, data: blank_program_obj });
    };
    const BtnNewCustomer = () => {
            handleChange({ setScreen: 2, data: blank_client_obj });
    };
    const BtnNewAcademicArea = () => {
            handleChange({ setScreen: 2, data: blank_academic_area_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    function handleSelectedTableGrid(table_type) {
        switch (table_type) {
            case 1:
                setTableType(table_type);
                break;
            case 2:
                setTableType(table_type);
                break;
            case 3:
                setTableType(table_type);
                break;
            case 4:
                setTableType(table_type);
                break;
            case 5:
                setTableType(table_type);
                break;
            default:
                setTableType(1);
                break;
        }

    }

    useEffect(() => {
        if (!Heimdall([3])) {
            navigate('/home');
        }
        else {
            SetLastFeature(3);
        }        
    }, [screenType, defaultData, tableType]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 325)}           { 
                                                        tableType == 1 ? GetLabel(appLang, 318) 
                                                    : 
                                                        tableType == 2 ? GetLabel(appLang, 319)
                                                    : 
                                                        tableType == 3 ? GetLabel(appLang, 321)
                                                    :
                                                        tableType == 4 ? GetLabel(appLang, 322)
                                                    :
                                                        tableType == 5 ? GetLabel(appLang, 323)
                                                    :
                                                        GetLabel(appLang, 324)
                                                    }
                </p>
            </div>

            {/*     List of options buttons row     */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.text_center, MainStyle.mt_2].join(" ")}>
                        <button
                            style={{width: '90%'}}
                            className={[tableType != 1 ? MainStyle.btn_vanilla : MainStyle.btn_disabled, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_2].join(" ")}
                            onClick={() => {
                                if (tableType != 1) {
                                    handleSelectedTableGrid(1);
                                }
                            }}
                            disabled={tableType != 1 ? false : true}
                        >
                            {GetLabel(appLang, 326)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.text_center, MainStyle.mt_2].join(" ")}>
                        <button
                            style={{width: '90%'}}
                            className={[tableType != 2 ? MainStyle.btn_vanilla : MainStyle.btn_disabled, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_2].join(" ")}
                            onClick={() => {
                                if (tableType != 2) {
                                    handleSelectedTableGrid(2);
                                }
                            }}
                            disabled={tableType != 2 ? false : true}
                        >
                            {GetLabel(appLang, 327)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.text_center, MainStyle.mt_2].join(" ")}>
                        <button
                            style={{width: '90%'}}
                            className={[tableType != 3 ? MainStyle.btn_vanilla : MainStyle.btn_disabled, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_2].join(" ")}
                            onClick={() => {
                                if (tableType != 3) {
                                    handleSelectedTableGrid(3);
                                }
                            }}
                            disabled={tableType != 3 ? false : true}
                        >
                            {GetLabel(appLang, 328)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.text_center, MainStyle.mt_2].join(" ")}>
                        <button
                            style={{width: '90%'}}
                            className={[tableType != 4 ? MainStyle.btn_vanilla : MainStyle.btn_disabled, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_2].join(" ")}
                            onClick={() => {
                                if (tableType != 4) {
                                    handleSelectedTableGrid(4);
                                }
                            }}
                            disabled={tableType != 4 ? false : true}
                        >
                            {GetLabel(appLang, 329)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.text_center, MainStyle.mt_2].join(" ")}>
                        <button
                            style={{width: '90%'}}
                            className={[tableType != 5 ? MainStyle.btn_vanilla : MainStyle.btn_disabled, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.py_3,
                                        MainStyle.px_2].join(" ")}
                            onClick={() => {
                                if (tableType != 5) {
                                    handleSelectedTableGrid(5);
                                }
                            }}
                            disabled={tableType != 5 ? false : true}
                        >
                            {GetLabel(appLang, 330)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_1}/>
            </div>
            {DavidCopperfield(3,89,0) && (
                <div className={MainStyle.py_3}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_10}/>
                        <div className={MainStyle.col_lg_2}>
                            <div className={[MainStyle.mx_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_blue, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_5].join(" ")}
                                    onClick={
                                        tableType == 1 ?
                                            BtnNewSchool
                                        :
                                        tableType == 2 ?
                                            BtnNewArea
                                        :
                                        tableType == 3 ?
                                            BtnNewProgram
                                        :
                                        tableType == 4 ?
                                            BtnNewCustomer
                                        :
                                        tableType == 5 ?
                                            BtnNewAcademicArea
                                        :
                                        null
                                    }                            
                                >
                                    {GetLabel(appLang, 120)}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}            
            {/*          Table grid             */}
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        {
                            tableType == 1 ?
                                <SchoolTableGrid setProps={handleChange}/>
                            :
                            tableType == 2 ?
                                <AreaTableGrid setProps={handleChange}/>
                            :
                            tableType == 3 ?
                                <ProgramTableGrid setProps={handleChange}/>
                            :
                            tableType == 4 ?
                                <CustomerTableGrid setProps={handleChange}/>
                            :
                            tableType == 5 ?
                                <AcademicAreaTableGrid setProps={handleChange}/>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {
                        tableType == 1 ?
                            GetLabel(appLang, 331)
                        :
                        tableType == 2 ?
                            GetLabel(appLang, 332)
                        :
                        tableType == 3 ?
                            GetLabel(appLang, 333)
                        :
                        tableType == 4 ?
                            GetLabel(appLang, 334)
                        :
                        tableType == 5 ?
                            GetLabel(appLang, 335)
                        :
                            GetLabel(appLang, 336)
                    }
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                {
                    tableType == 1 ?
                        <SchoolEditPanel        setProps={handleChange} data={defaultData}/>
                    :
                    tableType == 2 ?
                        <AreaEditPanel          setProps={handleChange} data={defaultData}/>
                    :
                    tableType == 3 ?
                        <ProgramEditPanel       setProps={handleChange} data={defaultData}/>
                    :
                    tableType == 4 ?
                        <CustomerEditPanel      setProps={handleChange} data={defaultData}/>
                    :
                    tableType == 5 ?
                        <AcademicAreaEditPanel  setProps={handleChange} data={defaultData}/>
                    :
                    null
                }
            </div>
        </>
        }
        </>
    );
};